import Box from '@mui/material/Box'
import { Autocomplete } from '@mui/material'
import countries from 'i18n-iso-countries'
import { lang } from '../../../dom'
import TextField from '@mui/material/TextField'
import enLocale from 'i18n-iso-countries/langs/en.json'
import deLocale from 'i18n-iso-countries/langs/de.json'
import frLocale from 'i18n-iso-countries/langs/fr.json'
import esLocale from 'i18n-iso-countries/langs/es.json'
import trLocale from 'i18n-iso-countries/langs/tr.json'
import nlLocale from 'i18n-iso-countries/langs/nl.json'
import * as React from 'react'
import { AugmentedControllerRenderProps } from '../steps/hooks'

countries.registerLocale(enLocale)
countries.registerLocale(deLocale)
countries.registerLocale(frLocale)
countries.registerLocale(esLocale)
countries.registerLocale(trLocale)
countries.registerLocale(nlLocale)

export interface CountrySelectProps extends AugmentedControllerRenderProps {
    value: string
}

export const CountrySelect = React.forwardRef((props: CountrySelectProps, ref) => {
    const countryNames = countries.getNames(lang, { select: 'official' })
    const countryOptions = Object.keys(countryNames)
    return (
        <Autocomplete
            blurOnSelect={true}
            onChange={(e, newValue) => {
                if (props.onChange) {
                    props.onChange(newValue)
                }
            }}
            onBlur={e => props.onBlur()}
            value={props.value}
            sx={{ width: 300, maxWidth: '100%' }}
            options={countryOptions}
            autoHighlight
            getOptionLabel={(option: string) => option ? countryNames[option] : ''}
            renderOption={(props, option: string) => (
                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                    <img
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${option.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${option.toLowerCase()}.png 2x`}
                        alt=""
                    />
                    {countryNames[option]}
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    helperText={props.helperText}
                    error={props.error}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                />
            )}
        />
    )
})
